import * as React from 'react';
import type { SVGProps } from 'react';

const SvgAntDesignPlusOutlined1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={24} fill="none" {...props}>
    <path
      fill="#F32A52"
      d="M17.726 11.11H3.68c-.111 0-.167.062-.167.187v1.406c0 .125.056.188.167.188h14.047c.112 0 .168-.063.168-.188v-1.406c0-.125-.056-.188-.168-.188Z"
    />
  </svg>
);
export default SvgAntDesignPlusOutlined1;
